export default __webpack_public_path__ + "static/media/calendar-icon.449bcfaa.svg";